import { lazy } from "react";

const routes = [
  {
    role: "ROLE_FULLFILLMENT_CENTER",

    path: "/material-movement",
    element: lazy(() => import("../pages/material-movement")),
  },
  {
    role: "ROLE_FULLFILLMENT_CENTER",

    path: "/lot_items/:lot_id",
    element: lazy(() => import("../pages/Fulfillment/LotItems")),
  },
  {
    role: "ROLE_FULLFILLMENT_CENTER",

    path: "/reverse_lot_items/:lot_id",
    element: lazy(() => import("../pages/Fulfillment/ReverseLotItems")),
  },
  {
    role: "ROLE_FULLFILLMENT_CENTER",

    path: "/fc_money_movement",
    element: lazy(() => import("../pages/Fulfillment/FCCollectionLedger/page")),
  },
];

export default routes;
